import type { CSSProperties } from 'react'
import { cx } from './utils/cx'
import type { AccentVar } from './AccentContext'

interface AvatarProps {
  initials: string
  color?: AccentVar | string
  // `sm`/`lg` preset hooks into components.css sizing. Or pass a number
  // for a one-off pixel size (public transfer headers do this).
  size?: 'sm' | 'lg' | number
  borderWidth?: string
  style?: CSSProperties
}

export function Avatar({ initials, color = '--mauve', size, borderWidth, style }: AvatarProps) {
  const presetClass = typeof size === 'string' ? size : undefined
  const numericStyle =
    typeof size === 'number'
      ? {
          width: size,
          height: size,
          fontSize: Math.round(size * 0.37)
        }
      : undefined
  const merged: CSSProperties = {
    background: `var(${color})`,
    ...(borderWidth ? { borderWidth } : null),
    ...numericStyle,
    ...style
  }
  return (
    <div className={cx('st-avatar', presetClass)} style={merged}>
      {initials}
    </div>
  )
}
